<ng-container *ngIf="!eliminaVisualizzazione && !waitNode && node">
    <div class="gx-0 position-relative" style="z-index: 3;">
        <div class="d-sm-flex justify-content-lg-center offset-md-2 offset-lg-0" [class.ps-3]="window.innerWidth < 769"
            [ngClass]="{'position-absolute container-breadcrumb': node.type[0].target_id === 'pagina' && (levelMenu.length === 1)}">
            <ng-container [ngSwitch]="node.type[0].target_id">
                <ng-container *ngSwitchCase="'pagina'">
                    <app-breadcrumb [levelMenu]="levelMenu" [levelMenuOther]="levelMenuOther"
                        [isSecondLevelUp]="isSecondLevelUp" class="mt-3" *ngIf="levelMenu && levelMenu.length > 1">
                    </app-breadcrumb>
                </ng-container>
                <ng-container *ngSwitchDefault>
                    <ng-container *ngIf="node.type[0].target_id !== 'corso_di_studi'">
                        <app-breadcrumb-first [title]="node.title[0].value" [type_page]="node.type[0].target_id" [isSecondLevelUp]="true"></app-breadcrumb-first>
                    </ng-container>
                </ng-container>
            </ng-container>
        </div>
    </div>
    <div *ngIf="levelMenu && levelMenu.length > 1 && node.type[0].target_id === 'pagina'" class="col-2 justify-content-center container-level-menu border-hidden-phone">
        <app-level-menu [levelMenu]="levelMenu" class="no-print"></app-level-menu>
    </div>
    <ng-container *ngIf="levelMenu && levelMenu.length > 1 && node.type[0].target_id === 'pagina'">
        <app-level-menu-expanded [levelMenu]="levelMenu" class="no-print"></app-level-menu-expanded>
    </ng-container>
    <ng-container *ngIf="
        node.type[0].target_id !== 'pagina' && 
        node.type[0].target_id !== 'corso_di_studi' && 
        node.type[0].target_id !== 'custom_layout_page' && 
        node.type[0].target_id !== 'persona'
    ">
        <app-back class="no-print position-relative" style="z-index: 5;"></app-back>
    </ng-container>
</ng-container>

<!-- TYPE OF CONTENT -->
<div class="node" (click)="closeHeader()" [ngStyle]="{'display': !isOpenMenu ? 'block' : 'none'}">
    <ng-container *ngIf="!waitNode && node && !statusError">
        <ng-container [ngSwitch]="node.type[0].target_id">
            <ng-container *ngSwitchCase="'custom_layout_page'">
                <app-page-custom [node]="node"></app-page-custom>
            </ng-container>
            <ng-container *ngSwitchCase="['notizia', 'archivio_notizia'].includes(node.type[0].target_id) ? node.type[0].target_id : false">
                <app-page-notizia [node]="node" [isSecondLevelUp]="levelMenu.length > 1"></app-page-notizia>
            </ng-container>
            <ng-container *ngSwitchCase="'pagina'">
                <app-page-general [node]="node" [isSecondLevelUp]="levelMenu.length > 1" [levelMenu]="levelMenu && levelMenu.length ? levelMenu : levelMenuOther" [isShowLocalMenu]="isShowLocalMenu"></app-page-general>
            </ng-container>
            <ng-container *ngSwitchCase="'bando'">
                <app-page-bando [node]="node" [isSecondLevelUp]="levelMenu.length > 1"></app-page-bando>
            </ng-container>
            <ng-container *ngSwitchCase="'avviso'">
                <app-page-avviso [node]="node" [isSecondLevelUp]="levelMenu.length > 1"></app-page-avviso>
            </ng-container>
            <ng-container *ngSwitchCase="'procedura_servizio'">
                <app-page-procedura [node]="node" [isSecondLevelUp]="levelMenu.length > 1"></app-page-procedura>
            </ng-container>
            <ng-container *ngSwitchCase="'faq'">
                <app-page-faq [node]="node" [isSecondLevelUp]="levelMenu.length > 1"></app-page-faq>
            </ng-container>
            <ng-container *ngSwitchCase="'convenzione'">
                <app-page-convenzione [node]="node" [isSecondLevelUp]="levelMenu.length > 1"></app-page-convenzione>
            </ng-container>
            <ng-container *ngSwitchCase="'alloggio_residenza'">
                <app-page-alloggio [node]="node" [isSecondLevelUp]="levelMenu.length > 1"></app-page-alloggio>
            </ng-container>
            <ng-container *ngSwitchCase="'persona'">
                <app-page-persona [node]="node" [isSecondLevelUp]="levelMenu.length > 1"></app-page-persona>
            </ng-container>
            <ng-container *ngSwitchCase="'docente'">
                <app-page-docenti [node]="node" [isSecondLevelUp]="levelMenu.length > 1"></app-page-docenti>
            </ng-container>
            <ng-container *ngSwitchCase="['evento', 'archivio_evento'].includes(node.type[0].target_id) ? node.type[0].target_id : false">
                <app-page-evento [node]="node" [isSecondLevelUp]="levelMenu.length > 1"></app-page-evento>
            </ng-container>
            <ng-container *ngSwitchCase="'corso_di_studi'">
                <app-page-corso-di-studi [node]="node" [isSecondLevelUp]="levelMenu.length > 1" [levelMenu]="levelMenu"></app-page-corso-di-studi>
            </ng-container>
        </ng-container>
    </ng-container>
</div>

<ng-container *ngIf="statusError">
    <ng-container [ngSwitch]="statusError">
        <app-error400 *ngSwitchCase="400"></app-error400>
        <app-error401 *ngSwitchCase="401"></app-error401>
        <app-error403 *ngSwitchCase="403"></app-error403>
        <app-error404 *ngSwitchCase="404"></app-error404>
        <app-error500 *ngSwitchCase="500"></app-error500>
        <app-error503 *ngSwitchCase="503"></app-error503>
        <app-error-other *ngSwitchDefault [statusCode]="statusError"></app-error-other>
    </ng-container>
</ng-container>
<!-- END TYPE OF CONTENT -->
<!-- SCROLL ON TOP -->
<div *ngIf="isShow && !isOpenMobileLocalMenu" class="cursor-pointer scroll-top no-print" (click)="scrollOnTop()">
    <img loading="lazy" class="icon-ontop" src="../../../../../../assets/images/share-icon/onTop.png" alt="onTop icon">
</div>
<!-- END SCROLL ON TOP -->
<ng-template #modalLogin let-modal>
    <div class="modal-header">
        <h6 class="title-modal text-center" id="modal-basic-title">Login</h6>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body p-5">
        <div class="container">
            <app-login (onLoggedAdmin)="onLoggedAdmin($event)" [preview]="true"></app-login>
        </div>
    </div>
</ng-template>

<app-lumia-chat *ngIf="showLumiaChat"></app-lumia-chat>